import { ReactNode } from 'react';

import classNames from 'classnames';
import { Command } from 'cmdk';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxSeparatorProps {
  className?: string;
  children?: ReactNode;
}

export const ComboboxSeparator = ({ className, children }: ComboboxSeparatorProps) => {
  const { classNames: contextClassNames } = useComboboxContext();
  const styles = comboboxStyles();

  return (
    <Command.Separator
      alwaysRender
      className={classNames(styles.separator(), contextClassNames?.separator, className)}
    >
      {children}
    </Command.Separator>
  );
};
